// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"styles__container___3s1PM","steps":"styles__steps___3ccFs","card":"styles__card___1zSrs","card-icon":"styles__card-icon___W7K_8","cardIcon":"styles__card-icon___W7K_8","card-description":"styles__card-description___2jded","cardDescription":"styles__card-description___2jded","divider":"styles__divider___3SVih","divider-icon":"styles__divider-icon___3itlz","dividerIcon":"styles__divider-icon___3itlz","actions":"styles__actions___Wzioe"};
    if(module.hot) {
      // 1679366696013
      var cssReload = require("../../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  